import $ from 'jquery'

const optsCarouselHome = {
  owlPrev: '.owl-prev-home',
  owlNext: '.owl-next-home',
  owlItem: '.owl-item',
  jsSelector: '.owl-carousel-home',
  owlOpts: {
    nav: true,
    navText: ['<span class="Icon-freccia-thin-left u-text-r-l"></span>', '<span class="Icon-freccia-thin-right u-text-r-l"></span>'],
    items: 1,
    dots: true,
    loop: true,
    lazyLoad: true,
    margin: 20,
    mouseDrag: true,
    URLhashListener: true,
    startPosition: 'URLHash',
    responsive: false,
    stagePadding: 216,
    autoplay:true,
    autoplayTimeout:5000
  }
}

const init = function() {
  const $owl = $(optsCarouselHome.jsSelector)

  if ($owl.length <= 0) {
    return
  }

  require(['owl.carousel', './a11y', 'owl.carousel/dist/assets/owl.carousel.css'], () => {
    $(optsCarouselHome.owlPrev).click(() => $owl.trigger('prev.owl.carousel'))
    $(optsCarouselHome.owlNext).click(() => $owl.trigger('next.owl.carousel'))

    $owl.on('initialized.owl.carousel changed.owl.carousel refreshed.owl.carousel', (event) => {
      if (!event.namespace) return

      var carousel = event.relatedTarget,
        element = event.target,
        current = carousel.current()

        console.log(current);

      // $(`${optsCarouselHome.owlNext}[aria-controls='${element.id}']`)
      //   .toggleClass('u-visibilityHidden', current === carousel.maximum())
      //
      // $(`${optsCarouselHome.owlPrev}[aria-controls='${element.id}']`)
      //   .toggleClass('u-visibilityHidden', current === carousel.minimum())

      // $(optsCarouselHome.jsSelector + " .owl-item.active .Caption-item").fadeIn()
    })

    if ($( window ).width() <= 767 ) {
      optsCarouselHome.owlOpts.stagePadding = 0
    } else {
      var paddingLeft = parseInt($('.HeaderCustom .Grid').css('padding-left'))
      var marginLeft = parseInt($('.HeaderCustom-navbar').css('margin-left'))

      optsCarouselHome.owlOpts.stagePadding = paddingLeft + marginLeft
    }

    const settings = $.extend({}, optsCarouselHome.owlOpts || {}, $owl.data('carouselOptions'))

    // must be called after events initialization
    $owl.owlCarousel(settings)
  })
}

$(document).ready(init)

export default {
  optsCarouselHome,
  init
}



// WEBPACK FOOTER //
// ./src/components/carouselhome/index.js